import React from "react";
import {useTranslation} from "react-i18next";
import {RoleAdjustment} from "./User";
import {useApplicationFormatter} from "../applications/ApplicationProvider";
import {LightWeightApplication} from "../applications/Application";

/**
 * Explains why the server set account service roles differently than selected (SSO-292)
 */
export function RoleAdjustmentsNotice(props: {
  roleAdjustments: RoleAdjustment[]
}) {
  const {t} = useTranslation();
  const applicationFormatter = useApplicationFormatter();

  return (
    <>
      {t('User.roleAdjustments.title')}
      <ul style={{margin: 0, paddingLeft: '1.5em'}}>
        {props.roleAdjustments.map(adjustment => {
          const role = applicationFormatter.formatApplicationRole({
            application: {name: adjustment.application} as LightWeightApplication,
            role: adjustment.role
          });
          return <li key={adjustment.role + adjustment.type}>{t('User.roleAdjustments.' + adjustment.reason, {role})}</li>
        })}
      </ul>
    </>
  )
}
